import styles from './styles.module.scss';

interface DividerProps {
	className?: string;
}

export const Divider = ({ className }: DividerProps) => {
	return <span className={`${styles.divider} ${className ? className : ''}`} />;
};
